import { render, staticRenderFns } from "./ReportDetails.vue?vue&type=template&id=7cfca476&"
import script from "./ReportDetails.js?vue&type=script&lang=js&"
export * from "./ReportDetails.js?vue&type=script&lang=js&"
import style0 from "./ReportDetails.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports